import React, { Fragment, useState, useEffect, useContext } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import Columns from './components/Columns';
import { profileList, profileRemove } from '../../shared/queries/AccessProfile';
import Modal from '../../shared/components/Modal';
import GraphQl from '../../GraphQL';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import {
  ACTION_NAME,
  DEFAULT_PAGE_SIZE,
  SMART_BABY_USER,
  SMART_USER,
} from '../../shared/utils/constants';
import SmartContext from '../App/context/SmartContext';
import SmartTable from '../../shared/components/material-table';

const AccessProfile = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const context = useContext(SmartContext);
  const { loggedUser } = context;
  const { t, history, dispatch } = props;

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const listAllProfiles = () => {
    const query = profileList();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        setData(res.profileList);
        hideLoading();
      })
      .catch(() => {
        hideLoading();
        showNotificationAutoDestroy(
          'danger',
          t('erros.title'),
          t('erros.error-to-loading')
        );
      });
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      rowData,
    });
    history.push(`/minime/acesso/mnt/${rowData.id}`);
  };

  const addItemClickHandler = () => {
    history.push('/minime/acesso/mnt/0');
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({
      ...rowData,
    });
    toggleModal();
  };

  const deleteItem = () => {
    toggleModal();

    showLoading();
    const removeMutation = profileRemove(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('error.title'),
          t('errors.error-to-remove')
        );
      })
      .finally(() => {
        hideLoading();
        listAllProfiles();
      });
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find((a) => a.name === ACTION_NAME.REMOVE).disabled =
        loggedUser &&
        loggedUser.login.toUpperCase() !== SMART_BABY_USER &&
        copyProps.data.name === SMART_USER.MANAGER;
    }
  };

  useEffect(() => {
    listAllProfiles();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <SmartTable
                    data={data}
                    title={t('mnt_access_profiles.title')}
                    deleteActions={toggleModal}
                    columns={Columns(t)}
                    onRefreshClick={listAllProfiles}
                    onAddClick={addItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onEditClick={editItemClickHandler}
                    actionsDisabled
                    actionsDisabledByConditional={actionsDisabledByConditional}
                    pageSize={DEFAULT_PAGE_SIZE}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

AccessProfile.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(AccessProfile)
);
